// src/config.js
let _config = null;

export async function loadConfig() {
  const res = await fetch("/api/config");
  if (!res.ok) throw new Error(`Config fetch failed: ${res.status}`);
  _config = Object.freeze(await res.json());
}

// For apiClient.js — import { getConfig }
export function getConfig() {
  if (!_config) throw new Error("Call loadConfig() first");
  return _config;
}

// For Login.js, Register.js — import { config }
// Proxy preserves config.googleClientId syntax with no changes to those files
export const config = new Proxy({}, {
  get(_, key) {
    if (!_config) throw new Error(`Config not loaded yet — accessed config.${key} before bootstrap`);
    return _config[key];
  }
});